module.exports = __webpack_public_path__ + "img/loading.c552604c.svg";